import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import ProjectList, { IProjectList } from '../project/ProjectList';
import "../../assets/scss/project/project-intro.scss"
interface IProjectIntro {
    summary: string;
    projectLists: Array<IProjectList>
    title: string;
}


function ProjectIntro(props: IProjectIntro) {

    const projectLists = props.projectLists.map((projectList: IProjectList, index: number) => {
        return (
            <Col key={index} md={2} xs={true} >
                <ProjectList nameOfList={projectList.nameOfList} items={projectList.items} />
            </Col>
        );
    })


    return (
        <Container className="project-intro">
            <Row>
                <Col>
                    <h1>{props.title}</h1>
                </Col>
            </Row>
            <Row>
                {projectLists}
                <Col xs={{ offset: 0, span: 12, order: 'first' }} md={{ offset: 1, span: true, order: 'last' }} className="project-summary">
                    <p>
                        {props.summary}
                    </p>
                </Col>
            </Row>
        </Container>
    );
}

export default ProjectIntro;